import { useState } from 'react';
import Masonry from 'react-masonry-css';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './ImageScroller.module.css';
import images from "../../images";

const breakpoints = {
  default: 3,
};

const PRIORITY_LOAD_COUNT = 9;

const ImageScroller = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loadedImages, setLoadedImages] = useState([]);
  const [priorityLoaded, setPriorityLoaded] = useState(false);

  const handleImageClick = (index) => {
    navigate(`/image/${index}`, { state: { background: location } });
  };

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => {
      if (!prev.includes(index)) {
        const updated = [...prev, index];
        if (updated.length >= PRIORITY_LOAD_COUNT && !priorityLoaded) {
          setPriorityLoaded(true);
        }
        return updated;
      }
      return prev;
    });
  };

  return (
    <>
      {!priorityLoaded && (
        <div className={styles.fullPageLoader}>
          <div className={styles.loaderSpinner}></div>
        </div>
      )}

      <Masonry
        breakpointCols={breakpoints}
        className={styles.masonryGrid}
        columnClassName={styles.masonryGridColumn}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className={`${styles.imageWrapper} ${
              loadedImages.includes(index) ? styles.loaded : ""
            }`}
            style={{
              animationDelay: `${index * 0.05}s`,
            }}
            onClick={() => handleImageClick(index)}
          >
            {!loadedImages.includes(index) && <div className={styles.placeholder} />}
            <img
              src={image.src}
              alt={image.alt}
              className={styles.image}
              onLoad={() => handleImageLoad(index)}
            />
          </div>
        ))}
      </Masonry>
    </>
  );
};

export default ImageScroller;
